import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthorisationService } from 'src/app/services/auth/authorisation.service';
import { Features } from 'src/app/services/auth/features';
import { Leave } from '../../../classes/leave';
import { PlanningHasEntity } from '../../../classes/planning-has-entity.class';
import { Planning } from '../../../classes/planning.class';
import { Project } from '../../../classes/project.class';
import { UserPlanning } from '../../../classes/user-planning';
import { User } from '../../../classes/user.class';
import { CodaltComponent } from '../../../codalt.component';
import { ConfirmDialogService } from '../../../services/confirm-dialog-service/confirm-dialog.service';
import { PlanningDetailDialogService } from '../../../services/dialog/planning-detail-dialog.service';
import { LeaveService } from '../../../services/leave.service';
import { PlanningService } from '../../../services/planning/planning.service';
import { UserPlanningService } from '../../../services/planning/user-planning.service';
import type { BlockedUser } from '../employee-planning-user-row/employee-planning-user-row.component';

@Component({
    selector: 'app-employee-day-info-dialog',
    templateUrl: './employee-day-info-dialog.component.html',
    styleUrls: ['./employee-day-info-dialog.component.scss'],
    standalone: false,
})
export class EmployeeDayInfoDialogComponent extends CodaltComponent {
    readonly = !AuthorisationService.hasFeature(Features.PlanningSaveSave);

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            planningHas: PlanningHasEntity[];
            userPlanning: UserPlanning[];
            leaves: Leave[];
            afasLeave: BlockedUser;
            projects: Project[];
            planningList: Planning[];
            user: User;
            day: Date;
            showLinks: boolean;
        },
        public planningDetailDialogService: PlanningDetailDialogService,
        private userPlanningService: UserPlanningService,
        private planningService: PlanningService,
        private leaveService: LeaveService,
        private confirmDialogService: ConfirmDialogService
    ) {
        super();

        [...data.planningHas, ...data.userPlanning].forEach(item => {
            item.planning = data.planningList.find(p => p.id === item.planning_id);

            if (item.planning && !item.planning.project) {
                item.planning.project = data.projects.find(p => p.afas_project_id === item.planning.afas_project_id);
            }

            item.project = data.projects.find(p => p.afas_project_id === item.afas_project_id);
        });
    }

    private confirmDelete(title: string, subject: string) {
        return this.confirmDialogService.confirm({
            title,
            text: `Weet u zeker dat u ${subject} wilt verwijderen?`,
            confirm: 'Verwijderen',
            cancel: 'Annuleren',
        });
    }

    deleteUserPlanning(userPlanning: UserPlanning) {
        this.confirmDelete('Planning verwijderen', 'deze planning').then(() => {
            this.subscriptions.add(
                this.userPlanningService.deleteUserPlanning(userPlanning.id).subscribe(() => {
                    this.data.userPlanning.splice(this.data.userPlanning.indexOf(userPlanning), 1);
                })
            );
        });
    }

    deletePlanningHas(planningHas: PlanningHasEntity) {
        this.confirmDelete('Planning verwijderen', 'deze planning').then(() => {
            this.planningService.deleteSingle(planningHas).then(() => {
                this.data.planningHas.splice(this.data.planningHas.indexOf(planningHas), 1);
            });
        });
    }

    deleteLeave(leave: Leave) {
        this.confirmDelete('Verlof verwijderen', 'dit verlof').then(() => {
            if (leave?.common) {
                leave.excluded.push({ user_id: this.data.user.id, date: this.data.day });
            } else {
                const index = leave.users.findIndex(u => u.id === this.data.user.id);
                if (index > -1) {
                    leave.users.splice(index, 1);
                }
            }

            this.subscriptions.add(
                this.leaveService.saveLeave({ ...leave, users: leave.users?.map(u => u.id) }).subscribe(() => {
                    this.data.leaves = this.data.leaves.filter(l => l.id !== leave.id);
                })
            );
        });
    }
}
